/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Stack, RadioButton, Button, ButtonGroup } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import history from 'src/routes/history';
import { routes } from 'src/routes';
import * as installActions from 'actions/install-actions';

type Props = {
  handleChangeState: () => void
};

type State = {
  value: number
};

type ComposedProps = Props & WithI18nProps;

class Options extends Component<ComposedProps, State> {
  state = {
    value: 1
  };

  render() {
    const { value } = this.state;
    const { i18n } = this.props;

    return (
      <div>
        <Stack vertical>
          <RadioButton
            label={i18n.translate('AdminHTML.Installation.Feedback.option1_RadioButton_Label')}
            checked={value === 1}
            id="1"
            name="options"
            onChange={this.handleChangeState}
          />

          <RadioButton
            label={i18n.translate('AdminHTML.Installation.Feedback.option2_RadioButton_Label')}
            id="2"
            name="options"
            checked={value === 2}
            onChange={this.handleChangeState}
          />

          <RadioButton
            label={i18n.translate('AdminHTML.Installation.Feedback.option3_RadioButton_Label')}
            id="3"
            name="options"
            checked={value === 3}
            onChange={this.handleChangeState}
          />

          <RadioButton
            label={i18n.translate('AdminHTML.Installation.Feedback.option4_RadioButton_Label')}
            id="4"
            name="options"
            checked={value === 4}
            onChange={this.handleChangeState}
          />

          <RadioButton
            label={i18n.translate('AdminHTML.Installation.Feedback.options_OtherQuestions')}
            id="5"
            name="options"
            checked={value === 5}
            onChange={this.handleChangeState}
          />
          <div style={{ marginLeft: 'auto' }}>
            <ButtonGroup>
              <Button onClick={this.backStep1}>
                {i18n.translate('AdminHTML.Common.Action.back')}
              </Button>

              <Button primary onClick={this.nextFeedback}>
                {i18n.translate('AdminHTML.Common.Action.next')}
              </Button>
            </ButtonGroup>
          </div>
        </Stack>
      </div>
    );
  }

  // Handle change value
  handleChangeState = (checked, newValue) => {
    this.setState({ value: parseInt(newValue) });
  };

  // Handle next step
  nextFeedback = () => {
    const { value } = this.state;
    const { handleChangeState } = this.props;

    handleChangeState(value);
  };

  // handle back to step 1
  backStep1 = async () => {
    /**
     * update tenant app install status
     * param: status - type: string
     */
    const { updateInstallationStatus} = this.props;
    await updateInstallationStatus('accepted-permissions');
    history.push(routes.newInstallation.onboarding());
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateInstallationStatus: status => dispatch(installActions.updateInstallationStatus(status))
});

export default withI18n()(connect(null, mapDispatchToProps)(Options));
